import RequestAbstract from "../abstract";

export default class PublicGatewayTemplates extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/public-gateway-templates";
    }
}
